/* eslint-disable */
import {
  Autocomplete,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import SearchIcon from "@mui/icons-material/Search";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import CleaningServicesIcon from "@mui/icons-material/CleaningServices";
import { Add } from "@mui/icons-material";
import { Box } from "@mui/system";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState, useContext } from "react";
import { getTarjetasBancos } from "../../services/TarjetaBancoService";
import TarjetaBancoAcuerdoDialog from "./TarjetaBancoAcuerdoDialog";
import { getTarjetas } from "../../services/TarjetaService";
import { getAcuerdosTarjetaBanco, getAcuerdoTarjetaBanco } from "../../services/TarjetaBancoAcuerdoService";
import { parse } from 'date-fns';
import Message from "../../utils/Message";
import WaitingDialog from "../../utils/WaitingDialog";
import AuthContext from "../../contexts/AuthContext";

const initialSearchData = {
  bancoEntidad: "",
  idTarjeta: "",
  idTarjetaBanco: "",
  fechaVigenciaDesde: null,
  fechaVigenciaHasta: null,
  estado: "habilitado",
};

const estadoOptions = [
  {
    id: "todo",
    descripcion: "Todo",
  },
  {
    id: "habilitado",
    descripcion: "Habilitado",
  },
  {
    id: "deshabilitado",
    descripcion: "Deshabilitado",
  },
];

const nameItemsText = "Acuerdos: Tarjeta - Banco/Entidad ";
//
// #############################################################################
//
const TarjetaBancoAcuerdoTable = () => {
  const [searchData, setSearchData] = useState(initialSearchData);
  const [itemsCrud, setItemsCrud] = useState([]);
  const [itemCrud, setItemCrud] = useState({});
  const [actionCrud, setActionCrud] = useState("");
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [totalRowsCount, setTotalRowsCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [valueACTarjeta, setValueACTarjeta] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACTarjeta,
    setInputValueACTarjeta] = useState("");
  const [tarjetas, setTarjetas] = useState([]);

  const [valueACTarjetaBanco, setValueACTarjetaBanco] = useState({
    id: "",
    descripcion: "",
  });
  const [inputValueACTarjetaBanco,
    setInputValueACTarjetaBanco] = useState("");
  const [tarjetasBancos, setTarjetasBancos] = useState([]);

  const { hasPermission } = useContext(AuthContext);
  const _crearTarjetaBancoAcuerdo = hasPermission("tarjeta-banco-acuerdo-c");
  const _editarTarjetaBancoAcuerdo = hasPermission("tarjeta-banco-acuerdo-e");
  const _habilitarTarjetaBancoAcuerdo = hasPermission("tarjeta-banco-acuerdo-h");
  const _deshabilitarTarjetaBancoAcuerdo = hasPermission("tarjeta-banco-acuerdo-d");

  const tableColumns = [
    {
      field: "marca_tarjeta",
      headerName: "Tarjeta - Banco",
      headerAlign: "center",
      align: "left",
      flex: 4,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.marca_tarjeta + ' ' + params.row.tipo_tarjeta + ' ' + params.row.banco_entidad;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_vigencia_desde",
      headerName: "Vigencia Desde",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_vigencia_desde;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "fecha_vigencia_hasta",
      headerName: "Vigencia Hasta",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_vigencia_hasta;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "porcentaje_interes",
      headerName: "% de Interés",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.porcentaje_interes;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "porcentaje_descuento",
      headerName: "% de Descuento",
      headerAlign: "center",
      align: "right",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.porcentaje_descuento;
        _val = _val ? _val : 0;
        return _val.toFixed(2);
      },
    },
    {
      field: "validez",
      headerName: "Validez",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        const dias = [
          { key: "lunes", label: "Lun" },
          { key: "martes", label: "Mar" },
          { key: "miercoles", label: "Mie" },
          { key: "jueves", label: "Jue" },
          { key: "viernes", label: "Vie" },
          { key: "sabado", label: "Sab" },
          { key: "domingo", label: "Dom" },
        ];
        const seleccionados = dias
          .filter(dia => params.row[dia.key])
          .map(dia => dia.label);

        return seleccionados.length === 7 ? "Todos los días" : seleccionados.join(", ");
      },
    },
    {
      field: "habilitado",
      headerName: "Habilitado",
      headerAlign: "center",
      align: "center",
      flex: 1,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.habilitado ? "SI" : "";
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      headerAlign: "center",
      align: "left",
      flex: 1,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <>
          {params.row.habilitado && _editarTarjetaBancoAcuerdo && (
            <Tooltip title="editar">
              <IconButton
                size="small"
                aria-label="update"
                onClick={() =>
                  handleClickActionCrud(params.row, "update")
                }
              >
                <EditOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}

          {params.row.habilitado && _deshabilitarTarjetaBancoAcuerdo && (
            <Tooltip title="deshabilitar">
              <IconButton
                size="small"
                aria-label="disable"
                onClick={() =>
                  handleClickActionCrud(params.row, "disable")
                }
              >
                <RemoveCircleOutlineIcon />
              </IconButton>
            </Tooltip>
          )}

          {!params.row.habilitado && _habilitarTarjetaBancoAcuerdo && (
            <Tooltip title="habilitar">
              <IconButton
                size="small"
                aria-label="enable"
                onClick={() =>
                  handleClickActionCrud(params.row, "enable")
                }
              >
                <AddCircleOutlineOutlinedIcon />
              </IconButton>
            </Tooltip>
          )}
        </>
      ),
    },
  ];

  const handlePaginationModelChange = (newModel) => {
    setCurrentPage(newModel.page);
    setRowsPerPage(newModel.pageSize);
  };

  const tableOptions = {
    paginationMode: "server",
    rowCount: totalRowsCount,
    paginationModel: {
      page: currentPage,
      pageSize: rowsPerPage,
    },
    onPaginationModelChange: handlePaginationModelChange,
    pageSizeOptions: [10, 20, 30],
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
      MuiTablePagination: {
        labelRowsPerPage: "Filas:",
        labelDisplayedRows: ({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`,
      },
    },
    sx: {
      '& .MuiDataGrid-cell': {
        fontSize: '0.9em',
      },
      '& .MuiDataGrid-columnHeaders': {
        backgroundColor: '#f5f5f5',
      },
    },
  };

  //
  // ################################################################################
  // cuando cambia la pagina actual o la cantidad de filas por pagina
  //
  useEffect(() => {
    loadTarjeta();
    load();
  }, [currentPage, rowsPerPage]);
  //
  // ################################################################################
  //
  useEffect(() => {
    if (valueACTarjeta.id) {
      loadTarjetaBanco();
    }
  }, [valueACTarjeta]);
  //
  // ################################################################################
  //
  const load = async () => {

    if (!valueACTarjetaBanco.id) {
      return;
    }

    let _params = {
      idTarjetaBanco: searchData.idTarjetaBanco,
      estado: searchData.estado,
      rows: rowsPerPage,
      first: currentPage * rowsPerPage,
    };

    setIsDoingSomething(true);
    const response = await getAcuerdosTarjetaBanco(_params);
    setIsDoingSomething(false);

    if (response.ok) {
      let _response = response.data.data;
      setTotalRowsCount(response.data.count);
      setItemsCrud(_response);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ################################################################################
  //
  const loadTarjeta = async () => {
    const response = await getTarjetas();
    if (response.ok) {
      let _response = response.data.data
      setTarjetas(_response);
      setValueACTarjeta({
        id: "",
        descripcion: "",
      });
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const loadTarjetaBanco = async () => {

    const response = await getTarjetasBancos({ idTarjeta: valueACTarjeta.id });

    if (response.ok) {
      let _response = response.data.data
      setTarjetasBancos(_response);
      setValueACTarjetaBanco({
        id: "",
        descripcion: "",
      });
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  }
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setSearchData({
      ...searchData,
      [e.target.name]:
        e.target.type === "checkbox" ? e.target.checked : e.target.value,
    });
  };
  //
  // ################################################################################
  //
  const handleLimpiar = () => {
    setCurrentPage(0);
    setSearchData(initialSearchData);
    setItemsCrud([]);
    setValueACTarjeta({
      id: "",
      descripcion: "",
    });
    setValueACTarjetaBanco({
      id: "",
      descripcion: "",
    });
  };
  //
  // ################################################################################
  //
  const handleBuscar = () => {

    if (searchData.idTarjeta === "") {
      setMessage({
        messageText: "Debes seleccionar la Tarjeta",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (searchData.idTarjetaBanco === "") {
      setMessage({
        messageText: "Debes seleccionar el Banco-Entidad",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    if (currentPage !== 0) {
      setCurrentPage(0);
    } else {
      load();
    }
  };
  //
  // ################################################################################
  //
  const handleClickActionCrud = (itemCrud, action) => {
    let _itemCrud = {};

    if (action !== "new") {
      const loadItem = async () => {
        setIsDoingSomething(true);
        const response = await getAcuerdoTarjetaBanco({ id: itemCrud.id });
        setIsDoingSomething(false);

        if (response.ok) {
          let _response = response.data.data[0]
          _itemCrud = {
            id: _response.id,
            tarjeta: {
              id: _response.id_tarjeta,
              label: _response.marca_tarjeta.toUpperCase() + ' ' + _response.tipo_tarjeta.toUpperCase(),
            },
            tarjetaBanco: {
              id: _response.id_tarjeta_banco,
              label: _response.banco_entidad,
            },
            fechaVigenciaDesde: _response.fecha_vigencia_desde
              ? parse(_response.fecha_vigencia_desde, 'dd/MM/yyyy', new Date())
              : null,
            fechaVigenciaHasta: _response.fecha_vigencia_desde
              ? parse(_response.fecha_vigencia_hasta, 'dd/MM/yyyy', new Date())
              : null,
            cantidadCuotas: _response.cantidad_cuotas,
            porcentajeInteres: _response.porcentaje_interes,
            porcentajeDescuento: _response.porcentaje_descuento,
            habilitado: _response.habilitado,
            lunes: _response.lunes,
            martes: _response.martes,
            miercoles: _response.miercoles,
            jueves: _response.jueves,
            viernes: _response.viernes,
            sabado: _response.sabado,
            domingo: _response.domingo,
            descripcion: _response.descripcion,
            mensaje: _response.mensaje,
            observaciones: _response.observaciones,
            cft: _response.costo_financiero_total,
            tea: _response.tasa_efectiva_anual,
          };
          setActionCrud(action);
          setItemCrud(_itemCrud);
          setOpenDialog(true);
        } else {
          setMessage({
            messageText: response.messageText,
            severity: response.messageSeverity,
          });
          setShowMessage(true);
          return;
        }

      };
      loadItem();
    } else {
      setActionCrud(action);
      setItemCrud(_itemCrud);
      setOpenDialog(true);
    }
  };
  //
  // ################################################################################
  //
  const handleDialogSave = () => {
    load();
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //
  const handleDialogClose = () => {
    setOpenDialog(false);
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mx: 1, px: 1, pb: 1 }}>

            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Box sx={{ mt: 1 }} display="flex" justifyContent="space-between" alignItems="center">
                  <Typography variant="h5" display="block" gutterBottom >
                    {nameItemsText}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-tarjeta"
                  size="small"
                  value={valueACTarjeta && valueACTarjeta.id ? valueACTarjeta : null}
                  onChange={(event, newValue) => {
                    setValueACTarjeta(newValue);
                    setSearchData({
                      ...searchData,
                      idTarjeta: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACTarjeta}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACTarjeta(newInputValue);
                  }}
                  options={tarjetas}
                  getOptionLabel={(option) => (option.marca).toUpperCase() + " - " + (option.tipo).toUpperCase()}
                  renderInput={(params) => (
                    <TextField {...params} label="Tarjeta" />
                  )}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <Autocomplete
                  id="id-tarjeta-banco"
                  size="small"
                  value={valueACTarjetaBanco && valueACTarjetaBanco.id ? valueACTarjetaBanco : null}
                  onChange={(event, newValue) => {
                    setValueACTarjetaBanco(newValue);
                    setSearchData({
                      ...searchData,
                      idTarjetaBanco: newValue ? newValue.id : "",
                    });
                  }}
                  inputValue={inputValueACTarjetaBanco}
                  onInputChange={(event, newInputValue) => {
                    setInputValueACTarjetaBanco(newInputValue);
                  }}
                  options={tarjetasBancos}
                  getOptionLabel={(option) => option.banco_entidad}
                  renderInput={(params) => (
                    <TextField {...params} label="Banco - Entidad" />
                  )}
                  isOptionEqualToValue={(option, value) => {
                    if (!value || !value.id) return false;
                    return option.id === value.id;
                  }}
                  disableClearable={true}
                />
              </Grid>

              <Grid item xs={12} md={12} lg={2}>
                <FormControl sx={{ width: "100%" }}>
                  <InputLabel id="tipo-documento-select-label">
                    Estado
                  </InputLabel>
                  <Select
                    sx={{ width: "100%", mr: 1 }}
                    labelId="estado"
                    label="Estado"
                    id="estado"
                    name="estado"
                    value={searchData.estado}
                    size="small"
                    onChange={handleChange}
                  >
                    {estadoOptions.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.descripcion}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ mx: 1, mb: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1}>

              {_crearTarjetaBancoAcuerdo && (
                <Grid item xs={12} md={12} lg={1}>
                  <Box sx={{ display: "flex", gap: 1 }}>
                    <Tooltip title="crear nuevo acuerdo de tarjeta - banco/entidad">
                      <Button
                        fullWidth
                        className="btn-add"
                        variant="contained"
                        size="small"
                        onClick={() => handleClickActionCrud({}, "new")}
                        startIcon={<Add />}
                      >
                        Nueva
                      </Button>
                    </Tooltip>
                  </Box>
                </Grid>
              )}

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="buscar">
                    <Button
                      fullWidth
                      variant="contained"
                      size="small"
                      onClick={handleBuscar}
                      startIcon={<SearchIcon />}
                    >
                      Buscar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>

              <Grid item xs={12} md={12} lg={1}>
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Tooltip title="limpiar filtros de búsqueda">
                    <Button
                      fullWidth
                      variant="outlined"
                      size="small"
                      onClick={handleLimpiar}
                      startIcon={<CleaningServicesIcon />}
                    >
                      Limpiar
                    </Button>
                  </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Paper>

        <DataGrid
          rows={itemsCrud}
          columns={tableColumns}
          {...tableOptions}
        />
      </Paper>

      {openDialog && (
        <TarjetaBancoAcuerdoDialog
          onSave={handleDialogSave}
          onClose={handleDialogClose}
          itemCrud={itemCrud}
          actionCrud={actionCrud}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default TarjetaBancoAcuerdoTable;
